import store from "../../redux/store";
import { traceFlow } from "../../services/endUserService/endUserService";
import { traceFlowTransistionManager } from "../../services/transitionManagerServices";

export class AlertButtonToolbar extends HTMLElement {
  constructor() {
    super();
    this.handleAlertClick = this.handleAlertClick.bind(this);
    this.innerHTML = `
      <style>
        .alert-button {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 4px 10px;
          font-size: 12px;
          font-weight: 500;
          color: #ff9800;
          border: 1px solid #ff9800;
          border-radius: 4px;
          background: transparent;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .alert-button:hover {
          background-color: #ff9800;
          color: #fff;
        }
      </style>
      <div class="alert-button" title="Trace">Trace</div>
    `;
  }

  connectedCallback() {
    this.querySelector('.alert-button')?.addEventListener('click', this.handleAlertClick);
  }

  disconnectedCallback() {
    this.querySelector('.alert-button')?.removeEventListener('click', this.handleAlertClick);
  }

 async handleAlertClick() {
  try {
    const { aiResponseMessage } = store.getState().aiResponse;
    let parsedMessage: any = {};

    try {
      parsedMessage = typeof aiResponseMessage === 'string'
        ? JSON.parse(aiResponseMessage)
        : aiResponseMessage;
    } catch (e) {
      console.error("Failed to parse aiResponseMessage", e);
      return;
    }

    const traceId = parsedMessage?.traceId;
    if (!traceId) {
      console.error("No traceId found in aiResponseMessage");
      return;
    }

    // ✅ Route API based on path
    const path = window.location.pathname;
    let response;

    if (path.includes('/TransitionManagerDashboard')) {
      response = await traceFlowTransistionManager({ traceId });
    } else {
      response = await traceFlow({ traceId });
    }

    const traceEvent = new CustomEvent('trace-clicked', {
      detail: {
        success: true,
        data: response,
      },
      bubbles: true,
      composed: true,
    });

    this.dispatchEvent(traceEvent);

  } catch (error) {
    console.error("Error during traceFlow call:", error);

    const traceEvent = new CustomEvent('trace-clicked', {
      detail: {
        success: false,
        error: 'Unknown error',
      },
      bubbles: true,
      composed: true,
    });

    this.dispatchEvent(traceEvent);
  }
}

}

customElements.define('alert-button-toolbar', AlertButtonToolbar);